/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable fp/no-mutation */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import merge from 'lodash.merge';
import { commonMessages } from '../messages/common';
import { providerComparisonTableMessages } from '../messages/provider-comparison-table';
import { providerComparisonWidgetMessages } from '../messages/provider-comparison-widget';
export const ProviderComparisonWidgetTranslations = merge(undefined, commonMessages, providerComparisonWidgetMessages, providerComparisonTableMessages);
